
import Loadable from 'react-loadable';
import Spinner from '../../components/spinner';


export default Loadable({
  loader: () => import(/* webpackChunkName: "ItemQRScan"*/'./item-qr-scan'),
  loading: Spinner
});
